import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { OrderPricingPreviewRequestSchema2 } from '~/services/api/generated'
import { strictify } from '~/utils/strictify'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const normalize = fieldNormalizer({
  blankToNull: ['delivery_address'],
  lists: [{ key: 'items', spec: { blankToNull: ['special_instructions'] } }]
})

const schema = strictify(OrderPricingPreviewRequestSchema2)

export const OrderPricingPreview = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema)
